import React, { useEffect, useRef } from 'react';
import { useRouter } from 'next/router';
import classnames from 'classnames';

import styles from './Header.module.scss';

import {
  headerDefaultHeightDesktop,
  headerLogoColor,
  headerLogoWhite,
} from '../../utils/constants';
import { LOGO } from '../../utils/assets';
import routes from '../../utils/routes';

type HeaderT = {
  sticky?: boolean;
  type?: typeof headerLogoColor | typeof headerLogoWhite;
  rightComponent?: JSX.Element;
  hide?: boolean;
  wizard?: boolean;
  customClass?: string;
  logoRedirect?: boolean;
  brandingLogo?: string;
  brandingCode?: string;
};

const Header = ({
  sticky = false,
  type = headerLogoColor,
  rightComponent,
  hide = false,
  wizard = false,
  customClass,
  logoRedirect = false,
  brandingLogo,
  brandingCode,
}: HeaderT) => {
  const router = useRouter();
  const ref = useRef<HTMLElement>(null);
  const imgLogo = type === headerLogoWhite ? LOGO.WHITE : LOGO.COLOR;

  const classHeader = classnames(styles.header, {
    [`${customClass}`]: customClass,
    [styles.header_sticky]: !!sticky,
    [styles.header_hide]: !!sticky && !!hide,
  });

  const classLogo = classnames(styles.header_logo, {
    [styles.header_wizard]: !!wizard,
    [styles.header_logo_redirect]: logoRedirect,
  });

  useEffect(() => {
    const headerRef = ref.current;
    const headerHeight: number = headerRef?.offsetHeight || headerDefaultHeightDesktop;
    let previousPosition = window.pageYOffset;
    let timeOutEnd: any;

    const onScroll = () => {
      const currentYPosition = window.pageYOffset;

      clearTimeout(timeOutEnd);

      if (currentYPosition > headerHeight) {
        headerRef?.classList.add(styles.header_scrolled);

        if (hide) {
          if (previousPosition > currentYPosition) {
            headerRef?.classList.remove(styles.hide);
          } else {
            headerRef?.classList.add(styles.hide);
          }
        }

        previousPosition = currentYPosition;
      } else {
        headerRef?.classList.remove(styles.header_scrolled);
        hide && headerRef?.classList.remove(styles.hide);

        previousPosition = 0;
      }
    };

    if (sticky) {
      window.addEventListener('scroll', onScroll);
      onScroll();
    }

    return () => {
      window.removeEventListener('scroll', onScroll);
    };
  }, []);

  const onClickLogoHandler = () => {
    if (logoRedirect) {
      router.push(routes.landing);
    }
  };

  return (
    <header ref={ref} className={classHeader}>
      <div className={classLogo}>
        <img
          className={styles.header_logo_img}
          src={imgLogo}
          alt="Logo de bicevida"
          onClick={onClickLogoHandler}
        />
        {!!brandingLogo && (
          <>
            <img
              className={classnames(styles.logo_sponsor, {
                [styles.logo_sponsor_simplee]: brandingCode === 'simplee',
              })}
              src={brandingLogo}
              alt="Logo de sponsor"
            />
          </>
        )}
      </div>

      {!!rightComponent && <div className={styles.header_right_container}>{rightComponent}</div>}
    </header>
  );
};

export default Header;
